module.exports = __webpack_public_path__ + "static/media/tastingnotes_plus.5c474b2f.png";